import type { WidgetId } from './idTypes';
import { TreeNode } from './structuredContentTypes';

enum GradientType {
  LinearGradient = 'linear-gradient',
  RadialGradient = 'radial-gradient',
}

type Gradient = {
  type: GradientType;
  colors: string[];

  // Angle in degrees, for linear gradients only
  angle?: number;

  // Circle at center property, for radial gradient only
  circleAtCenter?: string;
};

interface BackgroundPattern {
  id: string;
  svgPattern: string;
}

type PageBackgroundData = Pick<Page, 'background' | 'gradientBackground' | 'backgroundPattern'>;

interface Page {
  // Solid colour
  background: string;

  // Gradient background
  // Will override solid background if defined and not null
  gradientBackground?: Gradient | null;

  backgroundPattern?: BackgroundPattern;

  widgetLayerOrder: WidgetId[];
  widgetStructureTree: TreeNode;
}

export { GradientType };
export type { Page, Gradient, PageBackgroundData, BackgroundPattern };
